import { render } from "./FloristMeetingInput.vue?vue&type=template&id=2fddbab2&scoped=true"
import script from "./FloristMeetingInput.vue?vue&type=script&lang=js"
export * from "./FloristMeetingInput.vue?vue&type=script&lang=js"

import "./FloristMeetingInput.vue?vue&type=style&index=0&id=2fddbab2&scoped=true&lang=css"

import exportComponent from "/home/ec2-user/environment/links-frontend/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fddbab2"]])

export default __exports__